import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import api from "../lib/api";
import { X, Sparkles } from "lucide-react";

export default function PromoPopin({ user }) {
    const [promo, setPromo] = useState(null);
    const [open, setOpen] = useState(false);
    const location = useLocation();
    const suppressed = ["/book", "/admin", "/checkout", "/login", "/register", "/forgot-password", "/reset-password"].some((p) => location.pathname.startsWith(p));

    useEffect(() => {
        if (suppressed) return;
        const seen = sessionStorage.getItem("tresses_repeat_promo_seen");
        if (!user || seen) return;
        if ((user.total_bookings || 0) < 1) return;
        api.get("/promotions", { params: { repeat_only: true } }).then((r) => {
            if (r.data && r.data.length) {
                setPromo(r.data[0]);
                setOpen(true);
                sessionStorage.setItem("tresses_repeat_promo_seen", "1");
            }
        }).catch(() => {});
    }, [user, suppressed]);

    useEffect(() => {
        if (!open) return;
        const onKey = (e) => { if (e.key === "Escape") setOpen(false); };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [open]);

    if (suppressed || !open || !promo) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-[#3D0C1F]/45 backdrop-blur-sm px-4" data-testid="promo-popin">
            <div className="relative max-w-lg w-full bg-[#FDF0EC] border border-[#C29A5B]/40 grain">
                <button
                    onClick={() => setOpen(false)}
                    className="absolute top-4 right-4 text-[#7A5262] hover:text-[#8F622C]"
                    data-testid="promo-popin-close"
                >
                    <X size={20} />
                </button>
                {promo.image && (
                    <div className="aspect-[16/8] bg-cover bg-center" style={{ backgroundImage: `url(${promo.image})` }} />
                )}
                <div className="p-8">
                    <div className="flex items-center gap-2 text-[#8F622C]">
                        <Sparkles size={14} />
                        <span className="text-overline">Just for you</span>
                    </div>
                    <h3 className="font-serif-display text-3xl mt-3 text-[#3D0C1F]">{promo.title}</h3>
                    <p className="text-sm text-[#7A5262] mt-3 leading-relaxed">{promo.description}</p>
                    <div className="mt-6 inline-block px-4 py-2 border border-[#C29A5B] text-[#8F622C] text-xs tracking-[0.2em]">
                        {promo.discount_label}
                    </div>
                </div>
            </div>
        </div>
    );
}
